module.exports = __webpack_public_path__ + "static/gpon_aurora-4d13c92048396beb6d04b1a718cc006d.svg";